export async function postEventToIterable({
  email,
  eventName,
}: {
  email: string;
  eventName: string;
}): Promise<void> {
  const res = await fetch('/api/iterable', {
    method: 'POST',
    body: JSON.stringify({ email, eventName }),
  });
  if (res.status !== 200) {
    throw new Error(`Error posting to iterable: ${res.status} ${res.url} ${res.text()}`);
  }
}
